import { GET_PROGRAM_SUBCATEGORIES } from "constants/programSubcategories";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_PROGRAM_SUBCATEGORIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
